import { combineReducers } from "redux";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { FETCH_COMMUNICATION_WAYS_REQUEST } from "./constants";
import { Action, CommunicationWaysState } from "./types";

function item(state: CommunicationWaysState = {}, action: Action): CommunicationWaysState {
  switch (action.type) {
    case getSuccessActionType(FETCH_COMMUNICATION_WAYS_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_COMMUNICATION_WAYS_REQUEST:
      return true;
    case getSuccessActionType(FETCH_COMMUNICATION_WAYS_REQUEST):
    case getFailureActionType(FETCH_COMMUNICATION_WAYS_REQUEST):
      return false;

    default:
      return state;
  }
}

export const communicationWays = combineReducers({ item, isFetching });
